var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yJQpXcg5hnmPAoMSoLMbGa",
    x1: 32,
    x2: 32,
    y1: 9.083,
    y2: 54.676,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yJQpXcg5hnmPAoMSoLMbGa)",
    d: "M50,55H14c-2.757,0-5-2.243-5-5V14c0-2.757,2.243-5,5-5h36c2.757,0,5,2.243,5,5v36 C55,52.757,52.757,55,50,55z M14,11c-1.654,0-3,1.346-3,3v36c0,1.654,1.346,3,3,3h36c1.654,0,3-1.346,3-3V14c0-1.654-1.346-3-3-3H14 z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yJQpXcg5hnmPAoMSoLMbGb",
    x1: 19,
    x2: 19,
    y1: 25,
    y2: 38.666,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yJQpXcg5hnmPAoMSoLMbGb)",
    d: "M18,26.004C18,25.434,18.425,25,19,25s1,0.434,1,1.004C20,26.566,19.575,27,19,27 S18,26.566,18,26.004z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yJQpXcg5hnmPAoMSoLMbGc",
    x1: 19,
    x2: 19,
    y1: 29,
    y2: 39,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yJQpXcg5hnmPAoMSoLMbGc)",
    d: "M18 29H20V39H18z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yJQpXcg5hnmPAoMSoLMbGd",
    x1: 29,
    x2: 29,
    y1: 25,
    y2: 38.998,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yJQpXcg5hnmPAoMSoLMbGd)",
    d: "M35,31.995c0,4.293-2.264,7.003-5.991,7.003c-3.736,0-6.009-2.701-6.009-7.003 C23,27.683,25.318,25,29.009,25C32.718,25.001,35,27.693,35,31.995z M25.042,31.995c0,3.081,1.498,5.069,3.967,5.069 c2.443,0,3.95-1.989,3.95-5.069c0-3.099-1.506-5.061-3.95-5.061C26.584,26.935,25.042,28.896,25.042,31.995z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yJQpXcg5hnmPAoMSoLMbGe",
    x1: 42,
    x2: 42,
    y1: 25.001,
    y2: 39,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yJQpXcg5hnmPAoMSoLMbGe)",
    d: "M39.008,35.085c0.172,1.267,1.382,2.073,3.125,2.073c1.626,0,2.818-0.86,2.818-2.044 c0-1.018-0.758-1.628-2.484-2.044l-1.68-0.417c-2.358-0.564-3.433-1.731-3.433-3.692c0-2.378,1.897-3.96,4.742-3.96 c2.646,0,4.58,1.582,4.697,3.831h-1.969c-0.19-1.231-1.237-1.998-2.755-1.998c-1.599,0-2.665,0.786-2.665,1.989 c0,0.953,0.687,1.499,2.384,1.906l1.436,0.361C45.898,31.728,47,32.839,47,34.846C47,37.4,45.067,39,41.977,39 c-2.89,0-4.832-1.526-4.977-3.914h2.008L39.008,35.085z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.b6d309bce2a9bba2d57da581e8ec0e03.svg";
export { ForwardRef as ReactComponent };